export default __webpack_public_path__ + "static/media/robyn.ddc90530.png";